(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('PaperErrorDetailController', PaperErrorDetailController);

    PaperErrorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PaperError', 'YieldCurveResults'];

    function PaperErrorDetailController($scope, $rootScope, $stateParams, previousState, entity, PaperError, YieldCurveResults) {
        var vm = this;

        vm.paperError = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:paperErrorUpdate', function(event, result) {
            vm.paperError = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
